var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper-container',_vm._b({ref:"swiper",on:{"swiperafterinit":_vm.init}},'swiper-container',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }